export default import.meta.ROLLDOWN_FILE_URL_IYugD6oYzZUy9Xg0sDhosQ